import { useProviderName } from 'hooks/useProviderName'

export default function ProviderName({ provider }: { provider: string }) {
  const providerName = useProviderName(provider)

  return <>{providerName}</>
}
